import { type SignTransactionOptions } from "@umami/chains";
import { getMnemonicFromSecretKey } from "@umami/state";
import { CustomError } from "@umami/utils";

export const getMnemonicFromOptions = (options: SignTransactionOptions): string => {
  if ("secretKey" in options) {
    return getMnemonicFromSecretKey(options.secretKey);
  } else if ("mnemonic" in options && options.mnemonic) {
    return options.mnemonic;
  }

  throw new CustomError("Ledger account not supported");
};
